import { createPageList } from '@/utils/createPageList'

const pages = createPageList(
  require.context(`../pages/docs/?meta=title,shortTitle,published`, false, /\.mdx$/),
  'docs'
)

export const documentationNav = {
  'Getting Started': [
    {
      title: 'Setup',
      href: '/docs/setup',
      match: /^\/docs\/setup/,
    },
    pages['commerce-definitions'],
    pages['checklist'],
    pages['appcustomisation'],
    pages['testingapp'],
    pages['products'],
    pages['translations'],
  ],
  'Building Blocks': [
    pages['users'],
    pages['listings'],
    pages['attributes'],
    pages['variants'],
    pages['category'],
    pages['media'],
    pages['review-ratings'],
    pages['location'],
    pages['schedules'],
    pages['search'],
    pages['tags'],
    pages['wishlist'],
    pages['qa-comments'],
    pages['notifications'],
    pages['negotiations'],
    pages['inventory'],
  ],
  Marketing: [
    pages['collection'],
    pages['promotion'],
    pages['coupon'],
    pages['seo'],
    pages['tracking'],
  ],
  'Marketplace & Platform': [pages['accounts'], pages['wallet'], pages['chat'], pages['social']],
  'Business Blocks': [
    pages['delivery'],
    pages['paymentgateways'],
    pages['revenuemodel'],
    pages['commission'],
    pages['order'],
    pages['tax'],
    // pages['inventory'],
  ],
  'System Blocks': [
    pages['auth'],
    pages['language'],
    pages['currency'],
    pages['email'],
    pages['domain'],
  ],
  'Editor Guides': [
    pages['template-create'],
    pages['editor-overview'],
    pages['editing-page-styles'],
    pages['dynamic-page'],
    pages['submit-template'],
  ],
  Deployment: [
    pages['deployment'],
    pages['playstore'],
    pages['appstore'],
    pages['vercel'],
    pages['netlify'],
  ],
  'Native Integrations': [
    pages['integrations-overview'],
    pages['webhook'],
    pages['zapier'],
    pages['firebase'],
    pages['stripe-payments'],
    pages['stripe-connect'],
    pages['stripe-onboarding'],
    pages['mangopay'],
    pages['onlinepaymentplatform'],
    pages['stuart'],
    pages['branch'],
    pages['google-maps'],
    pages['ga'],
    pages['facebookapp'],
  ],
  'Solution - UNSDG Goals': [
    pages['crowdfunding'],
    pages['food'],
    pages['education'],
    pages['energy'],
    pages['othersolutions'],
  ],
}
